/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Faq_A4Inputs */

const en_pc_alt_faq_a4 = /** @type {(inputs: Pc_Alt_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDFsam Basic and Okular both run on Linux, and browser-based tools work there too. Adobe Acrobat and Foxit PDF Editor do not offer Linux desktop apps.`)
};

const zh_pc_alt_faq_a4 = /** @type {(inputs: Pc_Alt_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDFsam Basic 和 Okular 都能在 Linux 上运行，浏览器端工具也可以使用。Adobe Acrobat 和 Foxit PDF Editor 不提供 Linux 桌面版。`)
};

/**
* | output |
* | --- |
* | "PDFsam Basic and Okular both run on Linux, and browser-based tools work there too. Adobe Acrobat and Foxit PDF Editor do not offer Linux desktop apps." |
*
* @param {Pc_Alt_Faq_A4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_faq_a4 = /** @type {((inputs?: Pc_Alt_Faq_A4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Faq_A4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_faq_a4(inputs)
	return zh_pc_alt_faq_a4(inputs)
});
export { pc_alt_faq_a4 as "pc.alt.faq.a4" }